import React from 'react'
import styled, { css } from 'styled-components'
import { Flex, Link } from '@raysync/common/components'
import intl from 'react-intl-universal'
import { Media, textEllipsis } from '@raysync/common/theme'

const BreadCrumbContainer = styled(Flex)`
  ${({ theme: { color } }) => css`
    justify-content: flex-start;
    align-items: center;
    max-width: 600px;
    a,
    span {
      text-decoration: none;
      color: #252a3a;
      font-size: 14px;
      flex-shrink: 0;
      :last-child {
        color: ${color.secondary};
        flex-shrink: 1;
        ${textEllipsis}
      }
    }

    ${Media.phone`
      font-size: .4rem;
      margin-bottom: 0;
    `}
  `}
`
export const Delimiter = styled.span`
  color: ${p => (p.actived ? '#fd5c1f' : '#252a3a')} !important;
  font-size: 14px;
  margin: 0 3px;
`

export function BreadCrumb({ title, to }) {
  return (
    <BreadCrumbContainer>
      <Link to='/support/document/index'>帮助中心</Link>
      <Delimiter>&gt;</Delimiter>
      <Link to={to}>{title}</Link>
    </BreadCrumbContainer>
  )
}
function findNestedSlug(menus, slug) {
  if (!menus) return []
  for (let i = 0; i < menus.length; i++) {
    if (menus[i].slug === slug) {
      return [menus[i].title]
    }

    if (menus[i].menuChildren) {
      let nestedPath = findNestedSlug(menus[i].menuChildren, slug)
      if (nestedPath.length > 0) {
        return [menus[i].title, ...nestedPath]
      }
    }
  }
  return []
}

export function BreadCrumb2({ slug, menus }) {
  const titles = React.useMemo(() => {
    return findNestedSlug(menus, slug)
  }, [menus, slug])
  return (
    <BreadCrumbContainer>
      <Link to='/support/document/index'>帮助中心</Link>
      {titles.length &&
        titles.map((title, index) => (
          <React.Fragment key={index}>
            <Delimiter>&gt;</Delimiter>
            <span>{title}</span>
          </React.Fragment>
        ))}
    </BreadCrumbContainer>
  )
}
